import { render } from "./DashboardActive.vue?vue&type=template&id=2f3c850a"
import script from "./DashboardActive.vue?vue&type=script&lang=js"
export * from "./DashboardActive.vue?vue&type=script&lang=js"
script.render = render

export default script